module.exports = require('./helpers/bundle-url').getBundleURL('7JE76') + "wood.3afd7588.jpg" + "?" + Date.now();